import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { GetQuoteComponent } from './get-quote/get-quote.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { ConfirmationBoxComponent } from './confirmation-box/confirmation-box.component';
import { UploadDndComponent } from './upload-dnd/upload-dnd.component';
import { DndDirective } from './directives/dnd.directive';
import { LucideAngularModule, icons } from 'lucide-angular';
import { SortByOrderPipe } from '../services/sort-by-order.pipe';
import { CommentSideNavComponent } from './comment-sidenav/comment-sidenav.component';
import { CommonFilterComponent } from './common-filter/common-filter.component';
import { CategoryFormatterPipe } from '../pipe/category-formatter.pipe';
import { ShortNamePipe } from '../pipe/titlecase.pipe';
import { LineItemsComponent } from './line-items/line-items.component';
import { ShopHeaderComponent } from './shop-header/shop-header.component';
import { FooterComponent } from './footer/footer.component';
import { FormFooterComponent } from './form-footer/form-footer.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { UploadFileComponent } from './upload-file/upload-file.component';
import { ChatboxComponent } from './chatbox/chatbox.component';
import { QuickCartComponent } from './quick-cart/quick-cart.component';

const sharedComp = [  
  BreadcrumbComponent, 
  GetQuoteComponent, 
  ConfirmationBoxComponent, 
  UploadDndComponent, 
  DndDirective, 
  SortByOrderPipe,
  CommentSideNavComponent,
  CommonFilterComponent,
  CategoryFormatterPipe,
  ShortNamePipe,
  LineItemsComponent,
  ShopHeaderComponent,
  FormFooterComponent,
  FooterComponent,
  UploadFileComponent,
  ChatboxComponent
];


@NgModule({
  declarations: [
    ...sharedComp,
    QuickCartComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    NgxIntlTelInputModule,
    LucideAngularModule.pick(icons),
  ],
  exports: [
    ...sharedComp
  ]
})
export class ElementsModule { }
